// QA Configuration
// export const API_BASE_URL = "https://localhost:7047";
// export const SITE_URL = "https://localhost:7047/";

export const API_BASE_URL = "https://oebp.pegasuslogistics.com/api";
export const SITE_URL = "https://oebp.pegasuslogistics.com/";

//  export const API_BASE_URL = "https://plgtst.pegasuslogistics.com/api/orderentry";
//  export const SITE_URL = "https://plgtst.pegasuslogistics.com/orderentry/";

// export const API_BASE_URL = "https://test.seanergydigital.com/backend";
// export const SITE_URL = "https://test.seanergydigital.com/orderentry/";
// UAT Configuration
// export const API_BASE_URL = "https://omega.pegasuslogistics.com/uat";
// export const SITE_URL = "https://omega.pegasuslogistics.com";

export const activeConfig = {
  // clientId: "aaefd9cf-5604-4e27-ad70-04a737410d51",
  // authority: "647119b9-2120-453d-ab27-e02884c15a1b",
  // redirectUri: "https://test.seanergydigital.com/orderentry/dashboard",
  // clientId: "b6c78d1e-12f7-4e87-95fa-78c142190cfc",
  // authority: "23293be7-6169-47c7-9664-eb3842ccc7dc",
  // redirectUri: "https://plgtst.pegasuslogistics.com/orderentry/dashboard",
  clientId: 'b6c78d1e-12f7-4e87-95fa-78c142190cfc',
  authority: '23293be7-6169-47c7-9664-eb3842ccc7dc',
  redirectUri: 'https://oebp.pegasuslogistics.com/dashboard'
};

export const API_KEY = "AIzaSyDXn3Ln9cmvhhMaL1HciFo9LsEq23PoYks";
export const TERMS_CONDITIONS =
  "https://www.pegasuslogistics.com/terms-and-conditions/";

export const config = {
  login: `${API_BASE_URL}/login`,
  forgotPassword: `${API_BASE_URL}/GetPassword`,
  getPermissions: `${API_BASE_URL}/GetPermissions`,
  getCustomers: `${API_BASE_URL}/GetCustomers`,
  getDashboardActivityList: `${API_BASE_URL}/GetDashboardActivityList`,
  getDashboardAvgCounts: `${API_BASE_URL}/GetDashboardAvgCounts`,
  getActivityListByDate: `${API_BASE_URL}/GetActivityListByDate`,
  getActivityList: `${API_BASE_URL}/GetActivityList`,
  downloadActivityFile: `${API_BASE_URL}/DownloadActivityFile`,
  getUsersList: `${API_BASE_URL}/GetUsersList`,
  addUpdateUser: `${API_BASE_URL}/AddUpdateUser`,
  getConfigurationDetails: `${API_BASE_URL}/GetConfigurationDetails`,
  addUpdateConfiguration: `${API_BASE_URL}/AddUpdateConfiguration`,
  GetCustomersList: `${API_BASE_URL}/GetCustomersList`,
  addUpdateCustomer: `${API_BASE_URL}/AddUpdateCustomer`,
  getPiaggioCustomersList: `${API_BASE_URL}/GetPiaggioCustomersList`,
  getPiaggioItemDetailsList: `${API_BASE_URL}/GetPiaggioItemDetailsList`,
  addUpdatePiaggioCustomer: `${API_BASE_URL}/AddUpdatePiaggioCustomer`,
  addUpdatePiaggioItemDetails: `${API_BASE_URL}/AddUpdatePiaggioItemDetails`,
  getCardtronicsCustomersList: `${API_BASE_URL}/GetCardtronicsCustomersList`,
  addUpdateCardtronicsCustomer: `${API_BASE_URL}/AddUpdateCardtronicsCustomer`,
  getInvalidOrderEntriesList: `${API_BASE_URL}/GetInvalidOrderEntriesList`,
  getInvoiceActivityList: `${API_BASE_URL}/GetInvoiceActivityList`,
  getInvoiceActivityListByDate: `${API_BASE_URL}/GetInvoiceActivityListByDate`,
  getInvoiceDetails: `${API_BASE_URL}/GetInvoiceDetails`,
  getInvalidInvoiceList: `${API_BASE_URL}/GetInvalidInvoiceList`,
  getVendors: `${API_BASE_URL}/GetVendors`,
  getDashboardInvoiceActivityList: `${API_BASE_URL}/GetDashboardInvoiceActivityList`,
  getDashboardInvoiceAvgCounts: `${API_BASE_URL}/GetDashboardInvoiceAvgCounts`,
  getServiceTypeLookup: `${API_BASE_URL}/GetServiceTypeLookup`,
  addUpdateServiceTypes: `${API_BASE_URL}/AddUpdateServiceTypes`,
  updateInvoiceMLResponse: `${API_BASE_URL}/UpdateInvoiceMLResponse`,
  getOrderEntryCustomersList: `${API_BASE_URL}/GetOrderEntryCustomersList`,
  getCustomerReferences: `${API_BASE_URL}/GetCustomerReferences`,
  addUpdateOrderEntryCustomer: `${API_BASE_URL}/AddUpdateOrderEntryCustomer`,
  getOrderEntryVendorsList: `${API_BASE_URL}/GetOrderEntryVendorsList`,
  addUpdateOrderEntryVendor: `${API_BASE_URL}/AddUpdateOrderEntryVendor`,
  getLozierStoreList: `${API_BASE_URL}/GetLozierStoreList`,
  getEcolabItemDetailsList: `${API_BASE_URL}/GetEcolabItemDetailsList`,
  getLozierDimensions: `${API_BASE_URL}/GetLozierDimensions`,
  addUpdateLozierStore: `${API_BASE_URL}/AddUpdateLozierStore`,
  addUpdateEcolabItemDetails: `${API_BASE_URL}/AddUpdateEcolabItemDetails`,
  getAllUsers: `${API_BASE_URL}/GetUsers`,
  getAllReferences: `${API_BASE_URL}/GetCustomerDropdownReferences`,
  getReferenceNoOptions: `${API_BASE_URL}/GetReferenceNoOptions`,
  getNautilusItemDetailsList: `${API_BASE_URL}/GetNautilusItemDetailsList`,
  addUpdateNautilusItemDetails: `${API_BASE_URL}/AddUpdateNautilusItemDetails`,
  getServiceTypesList: `${API_BASE_URL}/GetServiceTypesList`,
  addUpdateCustomerDetails: `${API_BASE_URL}/AddUpdateCustomerDetails`,
  getCustomerLineItemLookup: `${API_BASE_URL}/GetCustomerLineItemLookup`,
  getCustomerAddresses: `${API_BASE_URL}/GetCustomerAddresses`,
  addUpdateCustomerLineItem: `${API_BASE_URL}/AddUpdateCustomerLineItem`,
  addUpdateCustomerAddress: `${API_BASE_URL}/AddUpdateCustomerAddress`,
};
